<template>
  <div>
    <CardedForm
      ref="admin_sliders_form_ref"
      id="admin_sliders_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <TextField
            v-model="name"
            :validation_rules="name_rules"
            label="Name Of Slide"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pr-2">
          <SelectField
            v-model="page"
            :options="['home']"
            :small_chips="false"
            :validation_rules="page_rules"
            label="Page"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></SelectField>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <TextField
            v-model="position"
            :validation_rules="position_rules"
            label="Position"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pl-2">
          <ImageField
            label="Slide Picture"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="slides"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="slider_file_uploader"
            :required="true"
            empty_file_error="No slide image choosen"
            :default_value="default_thumbnail"
          >
          </ImageField>
        </v-col>
      </v-row>

      <TextField
        v-model="click_url"
        :validation_rules="click_url_rules"
        label="Click Url"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="comment"
        :validation_rules="comment_rules"
        label="Comment"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import ImageField from "../../../components/ImageField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminSlidersAdd",
  components: {
    CardedForm,
    TextField,
    SelectField,
    ImageField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      name: "",
      name_rules: [
        Utils.validate.is_required("Slide name is required"),
        Utils.validate.min_max_length(
          3,
          30,
          "Slide name should be between 3 and 30 characters "
        ),
      ],
      page: "home",
      page_rules: [Utils.validate.is_required("Page is required")],
      comment: "",
      comment_rules: [
        Utils.validate.max_length(
          60,
          "Comment should be less than 60 characters"
        ),
      ],
      position: 1,
      position_rules: [
        Utils.validate.is_required("Position is required"),
        Utils.validate.numeric("Position must be an integer value "),
        Utils.validate.min_max(1, 15, " Position has to be between 1 and 15"),
      ],
      click_url: "",
      click_url_rules: [
        Utils.validate.max_length(
          60,
          "Comment should be less than 60 characters"
        ),
      ],
      default_thumbnail: Utils.default_slide_thumbnail,
      slide_picture: "",
      id: 0,
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 456);

      this.name = "Slide_" + rnd;
      this.page = "home";
      this.click_url = "";
      this.position = 1;
      this.comment = rnd + " This is a very beautifull slide";
      this.slide_picture = this.default_thumbnail;

      this.errors = [];
      this.message = "";
    },
    init_editing_form(slide) {
      this.id = slide.id;
      this.name = slide.name;
      this.page = slide.page;
      this.click_url = slide.click_url;
      this.position = slide.position;
      this.comment = slide.comment;
      this.slide_picture = slide.slide_picture;

      this.errors = [];
      this.message = "";
      this.default_thumbnail = slide.slide_picture;
    },
    init_form() {
      this.name = "";
      this.page = "home";
      this.click_url = "";
      this.position = 1;
      this.comment = "";
      this.slide_picture = this.default_thumbnail;

      this.errors = [];
      this.message = "";
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.slide_picture = file_url;
      if (this.is_editing == true) {
        this.update_slide();
        // console.log("updated category ");
      } else {
        this.post_slide();
      }
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.admin_sliders_form_ref.show_error_dialog();
    },
    submit() {
      this.$refs.slider_file_uploader.upload_file();
    },
    post_slide() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Sliders.post_slider(
        {
          name: this.name,
          page: this.page,
          click_url: this.click_url,
          position: this.position,
          comment: this.comment,
          slide_picture: this.slide_picture,
        },
        (res) => {
          console.log("added slide res", res);
          this.$refs.admin_sliders_form_ref.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  New Slide was added successfully";
          this.$refs.admin_sliders_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.admin_sliders_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    update_slide() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Sliders.update_slider(
        {
          id: this.id,
          name: this.name,
          page: this.page,
          click_url: this.click_url,
          position: this.position,
          comment: this.comment,
          slide_picture: this.slide_picture,
        },
        (res) => {
          console.log("edit slide res", res);
          this.$emit("on-hide-loader");
          this.message =
            "<b>Update Operation Was Successfull</b> <br/>  Slide was edited successfully";
          this.$refs.admin_sliders_form_ref.show_message_dialog();
        },
        (errors) => {
          console.log("errros in editing slide submit logic: ", errors);
          this.errors = errors;
          this.$refs.admin_sliders_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add a New Slide",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Slides",
          disabled: false,
          href: "/admin/sliders",
        },
        {
          text: "New",
          disabled: true,
          href: "/admin/sliders/add",
        },
      ],
    });
    this.init_form();
  },
};
</script>